import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import Field from 'components/grid-form-field'
import FieldCount from 'components/grid-form-field-count'
import Input from 'components/grid-form-input'
import TextArea from 'components/grid-form-textarea'
import Button from 'components/grid-form-button'
import GridFormError from 'components/grid-form-error'
import Toggle from 'components/toggle'


import styles from './grid-ticket-modal-form.css'

const GridTicketModalForm = ({ fields, handleSubmit, onCancel }) => (
  <form styleName="grid-ticket-modal-form" onSubmit={handleSubmit} >

    <div styleName="fields">
      <Field border field={fields.name} label="Ticket Name">
        <Input />
        <GridFormError field={fields.name} />
      </Field>

      <div styleName="group">
        <Field border field={fields.quantity} label="How many tickets?">
          <Input />
          <GridFormError field={fields.quantity} />
        </Field>

        <div styleName="group-toggle">
          <Toggle checked={fields.isGroupTicket.checked} onChange={fields.isGroupTicket.onChange} />
          <span styleName="group-toggle-label">Group Ticket</span>
        </div>
      </div>

      {fields.isGroupTicket.checked &&
        <Field border field={fields.ticketIncrement} label="Ticket admits">
          <Input />
          <GridFormError field={fields.ticketIncrement} />
        </Field>
      }

      <div styleName="group">
        <Field field={fields.salePrice} label="Price">
          <Input />
          <GridFormError field={fields.salePrice} />
        </Field>

        <Field field={fields.faceValue} label="Face Value" optional="optional">
          <Input />
          <GridFormError field={fields.faceValue} />
        </Field>
      </div>
    </div>

    <div styleName="description">
      <FieldCount
        field={fields.description}
        label="Description..."
        optional="optional"
        maxChars={140}
      >
        <TextArea />
        <GridFormError field={fields.description} />
      </FieldCount>
    </div>

    <div styleName="actions">
      <Button secondary name="Cancel" onClick={onCancel} />
      <Button name="Save" onClick={handleSubmit} />
    </div>
  </form>
)

GridTicketModalForm.propTypes = {
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default CSSModules(GridTicketModalForm, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid-ticket-modal/grid-ticket-modal-form/grid-ticket-modal-form.js
 **/